export default "__VITE_ASSET__B$H34YfB__"